// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setHours as fn } from "../setHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setHours = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setHours;
